import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Home from './components/Page/Home';
import Result from './components/Page/Result';
import Detail from './components/Page/Detail';
import Draft from './components/Page/Draft';

function App() {
  return (
    <BrowserRouter basename="/esupport">
        <Switch>
          <Route path="/" exact component={Home}></Route>
          <Route path="/search" component={Result}></Route>
          <Route path="/detail/:url/:nexturl?" component={Detail}></Route>
          <Route path="/draft/:url" component={Draft}></Route>
          <Route component={Home}></Route>
        </Switch>
    </BrowserRouter>
  );
}

export default App;
